import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { StyledHeaderCell } from './styled';

const t = {
  insured: 'Insured',
  new: 'New',
  header_id: 'Order Id',
  header_shipper: 'Shipper',
  header_pallets: 'Pallets',
  header_weight: 'Weight',
  header_height: 'Height',
  header_extras: 'Extras',
  header_incidents: 'Incid.',
  header_distance: 'Distance',
  header_stops: 'Stops',
  not_reviewed: 'Not reviewed',
};

const sortingFields = {
  number_of_items: 'filtering_eu_pallets',
  weight: 'filtering_total_weight',
  height: 'filtering_container_height',
};

const ShipperOrderTableHeader = React.memo(({ filters, filterOrders, className }) => {
  const sort = useCallback(
    (field) => {
      if (filterOrders) {
        const { sorting = '' } = filters || {};

        if (!sorting) {
          filterOrders({
            ...filters,
            sorting: `+${field}`,
          });
          return;
        }

        const switchOrder = sorting.charAt(0) === '-' ? '+' : '-';
        const sortingField = sorting.includes(field) ? `${switchOrder}${field}` : `+${field}`;

        filterOrders({
          ...filters,
          sorting: sortingField,
        });
        return;
      }
    },
    [filterOrders, filters]
  );

  const sortByNumberOfItems = useCallback(() => {
    sort(sortingFields.number_of_items);
  }, [sort]);

  const sortByWeight = useCallback(() => {
    sort(sortingFields.weight);
  }, [sort]);

  const sortByHeight = useCallback(() => {
    sort(sortingFields.height);
  }, [sort]);

  const { sorting = '' } = filters || {};

  const isActive = useCallback(
    (field) => {
      return sorting.includes(field);
    },
    [sorting]
  );

  const getOrder = useCallback(
    (field) => {
      if (!isActive(field)) {
        return 'asc';
      }

      const mapChars = {
        '+': 'asc',
        '-': 'desc',
      };

      return mapChars[sorting.charAt(0)];
    },
    [sorting, isActive]
  );

  const { date } = filters;

  const isSortingEnabled = !!date;

  return (
    <div className={className}>
      <StyledHeaderCell cellWidth={84} mLeft="S">
        {t.header_id}
      </StyledHeaderCell>
      <StyledHeaderCell cellWidth={376}>{t.header_shipper}</StyledHeaderCell>
      <StyledHeaderCell
        cellWidth={60}
        textAlign="right"
        sortable={isSortingEnabled}
        active={isActive(sortingFields.number_of_items)}
        order={getOrder(sortingFields.number_of_items)}
        onClick={sortByNumberOfItems}
      >
        {t.header_pallets}
      </StyledHeaderCell>
      <StyledHeaderCell
        cellWidth={72}
        textAlign="right"
        sortable={isSortingEnabled}
        active={isActive(sortingFields.weight)}
        order={getOrder(sortingFields.weight)}
        onClick={sortByWeight}
      >
        {t.header_weight}
      </StyledHeaderCell>
      <StyledHeaderCell
        cellWidth={48}
        textAlign="right"
        sortable={isSortingEnabled}
        active={isActive(sortingFields.height)}
        order={getOrder(sortingFields.height)}
        onClick={sortByHeight}
      >
        {t.header_height}
      </StyledHeaderCell>
      <StyledHeaderCell cellWidth={128}>{t.header_extras}</StyledHeaderCell>
      <StyledHeaderCell cellWidth={24} />
      <StyledHeaderCell cellWidth={24}>{t.header_incidents}</StyledHeaderCell>
      <StyledHeaderCell cellWidth={56}>{t.header_distance}</StyledHeaderCell>
      <StyledHeaderCell grow pLeft="S">
        {t.header_stops}
      </StyledHeaderCell>
    </div>
  );
});

ShipperOrderTableHeader.propTypes = {
  className: PropTypes.string,
};

export default ShipperOrderTableHeader;
